/**
 * Must load before React / ReactFlow so ResizeObserver is patched early.
 * Suppresses benign "ResizeObserver loop" dev-overlay noise during flowchart export.
 */
(function setupResizeObserverSuppression() {
  if (typeof window === 'undefined') return;

  const isResizeObserverMessage = (message) => (
    typeof message === 'string'
    && (
      message.includes('ResizeObserver loop completed with undelivered notifications')
      || message.includes('ResizeObserver loop limit exceeded')
      || message.includes('ResizeObserver')
    )
  );

  const hideWebpackOverlay = () => {
    const overlayDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const overlayStyle = document.getElementById('webpack-dev-server-client-overlay');
    if (overlayDiv) overlayDiv.style.display = 'none';
    if (overlayStyle) overlayStyle.style.display = 'none';
  };

  if (window.ResizeObserver) {
    const NativeResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              try {
                callback(entries, observer);
              } catch (e) {
                if (!isResizeObserverMessage(e?.message)) {
                  throw e;
                }
              }
            });
          });
        });
      }
    };
  }

  const resizeObserverErrHandler = (event) => {
    const message = event?.message || event?.error?.message || '';
    if (!isResizeObserverMessage(message)) return;

    event.stopImmediatePropagation();
    event.preventDefault();
    hideWebpackOverlay();
  };
  window.addEventListener('error', resizeObserverErrHandler, true);

  const originalConsoleError = console.error;
  console.error = (...args) => {
    const firstArg = args[0];
    const isResizeObserverError = (
      (typeof firstArg === 'string' && firstArg.includes('ResizeObserver'))
      || (firstArg instanceof Error && firstArg.message.includes('ResizeObserver'))
    );
    const isReactFlowHandleError = (
      typeof firstArg === 'string' && firstArg.includes('[React Flow]: Couldn\'t create edge')
    );
    if (!isResizeObserverError && !isReactFlowHandleError) {
      originalConsoleError.apply(console, args);
    }
  };

  const originalOnError = window.onerror;
  window.onerror = function onError(message, source, lineno, colno, error) {
    if (isResizeObserverMessage(message) || isResizeObserverMessage(error?.message)) {
      hideWebpackOverlay();
      return true;
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };
}());
